type AttendanceGuest = {
  id: number;
  name: string;
  phone: string;
};

type AttendanceStatusModalProps = {
  open: boolean;
  title: string;
  noGuestsText: string;
  guests: AttendanceGuest[];
  onClose: () => void;
  closeLabel: string;
};

export default function AttendanceStatusModal({
  open,
  title,
  noGuestsText,
  guests,
  onClose,
  closeLabel,
}: AttendanceStatusModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "var(--modal-backdrop)" }}
    >
      <div className="w-full max-w-lg rounded-2xl border border-[color:var(--field-border)] bg-[color:var(--surface)] p-6 shadow-[var(--modal-shadow)]">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-[color:var(--foreground)]">{title}</h3>
          <button
            type="button"
            data-tab-trigger="true"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full border border-[color:var(--field-border)] bg-[color:var(--surface)] text-[color:var(--foreground)] transition hover:bg-[color:var(--surface-hover)]"
            aria-label={closeLabel}
            title={closeLabel}
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
        <div className="mt-4 max-h-[55vh] overflow-y-auto rounded-xl border border-[color:var(--field-border)]">
          {guests.length === 0 ? (
            <p className="px-4 py-6 text-sm text-[color:var(--muted)]">{noGuestsText}</p>
          ) : (
            <ul className="divide-y divide-[color:var(--divider)]">
              {guests.map((guest) => (
                <li key={guest.id} className="flex items-center justify-between px-4 py-3 text-sm">
                  <span className="font-medium text-[color:var(--foreground)]">{guest.name || "-"}</span>
                  <span className="text-[color:var(--muted)]">{guest.phone || "-"}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
